export enum RemovableEvents {
  SHOULD_REMOVE_ITEM = 'shouldRemoveItem',
}
